import Marquee from "react-fast-marquee";
import { BRAND_LOGOS } from "@/constants/brandLogos";

export const BrandLogoStrip = () => (
  <section
    className="border-y border-black/10 py-10 md:py-12 bg-white overflow-hidden"
    aria-label="Featured brands"
    data-testid="brand-logo-strip"
  >
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 mb-6">
      <p className="font-mono-acc uppercase tracking-[0.2em] text-xs text-vg-gray text-center">
        Trusted brands on our shelves
      </p>
    </div>

    <Marquee speed={35} autoFill gradient={false} pauseOnHover>
      {BRAND_LOGOS.map((brand) => (
        <div
          key={brand.name}
          className="mx-8 md:mx-12 flex h-24 w-24 md:h-32 md:w-32 items-center justify-center"
        >
          <img
            src={brand.src}
            alt={brand.name}
            title={brand.name}
            className="max-h-full max-w-full object-contain opacity-80 hover:opacity-100 transition-opacity duration-300"
            loading="lazy"
            draggable={false}
          />
        </div>
      ))}
    </Marquee>
  </section>
);

export default BrandLogoStrip;
